export enum CoverageMiss {
    PARTIALLY_MISSED,
    FULLY_MISSED
}